import { useTranslation } from "react-i18next";
import { Select } from "barte-design-system";
import { CreditCardIcon } from "@phosphor-icons/react";

import { CardInfo, InputNumber } from "@shared/components";

import type { CardDebitCardProps } from "./card-debit-card.type";
import styles from "./card-debit-card.module.css";

export const CardDebitCard = ({
    data,
    onChange,
    isLoading,
    errors,
    delayForRedeem,
    onChangeDelayForRedeem
}: CardDebitCardProps) => {
    const { t } = useTranslation();

    const title = (
        <div className={styles["card-header"]}>
            <CreditCardIcon /> {t("backoffice.pageModalCompanyPlanDebitTitle")}
        </div>
    ) as unknown as string;

    return (
        <CardInfo
            title={title}
            isLoading={isLoading}
            info={[
                {
                    label: t("backoffice.pageModalCompanyPlanRepassTimeLabel"),
                    value: (
                        <InputNumber
                            className={styles["input-field"]}
                            value={delayForRedeem}
                            onChange={(value) => onChangeDelayForRedeem?.(value)}
                            prefix="D + "
                            decimalPrecision={0}
                            error={errors?.delayForRedeem}
                            helperText={errors?.delayForRedeem || ""}
                        />
                    ),
                },
                {
                    label: t("backoffice.pageModalCompanyPlanRateTypeLabel"),
                    value: (
                        <Select
                            className={styles["input-field"]}
                            options={[
                                {
                                    value: "PERCENTAGE",
                                    label: t("backoffice.pageModalCompanyPlanRateTypePercentage"),
                                },
                                { value: "FIXED", label: t("backoffice.pageModalCompanyPlanRateTypeFixed") },
                            ]}
                            value={data?.rateType || "PERCENTAGE"}
                            onChange={(value) => onChange("rateType", value)}
                            hidePrefixIcon
                            disabled
                        />
                    ),
                },
                {
                    label: t("backoffice.pageModalCompanyPlanTotalChargedLabel"),
                    value: <InputNumber
                        className={styles["input-field"]}
                        value={data?.value}
                        onChange={(value: number) => onChange("value", value)}
                        prefix={data?.rateType === 'FIXED' ? "R$ " : undefined}
                        suffix={data?.rateType === 'PERCENTAGE' ? "%" : undefined}
                        error={errors?.value}
                        helperText={errors?.value || ""}
                    />
                },

            ]}
        />
    );
};
